/**
 * Types para la navegación
 */
export const UPDATE_NAVIGATION_EDITOR = '[EDITOR] UPDATE_NAVIGATION_EDITOR'
/**
 * Types para la questions
 */
export const UPDATE_STATUS_QUESTION_CHANGE = '[EDITOR] UPDATE_STATUS_QUESTION_CHANGE'

/**
 * Interfaces utiles
 */
interface IRouteEditor{
  id: string
  name: string
}

export interface INavigationEditor{
  alliance?: IRouteEditor
  program?: IRouteEditor
  subject?: IRouteEditor
}

/**
 * Interface para el store de Editor
 */
export interface IStateEditor{
  navigation: INavigationEditor
  statusQuestionChanged: boolean
}

/**
 * Interface para actualizar navegación
 */
interface IUpdateNavigationAction{
  type: typeof UPDATE_NAVIGATION_EDITOR,
  payload: INavigationEditor
}

/**
 * Interface para actualizar el estado de pregunta modificada
 */
interface IUpdateQuestionChangedStatus{
  type: typeof UPDATE_STATUS_QUESTION_CHANGE,
  payload: boolean
}

/**
 * Exportar types para actions
 */
export type IEditorActionTypes = IUpdateNavigationAction | IUpdateQuestionChangedStatus
